export default {"src":"/_next/static/image/public/images/icons1/4.9e750397a025b6343d1648e926633b8c.svg","height":21,"width":22};